import React from 'react'
import {
    CompactCardSkeletonContainer,
    CompactCardContentSection,
    CompactCardTopContent,
    CompactCardImageSkeleton,
    CompactCardBottomSection,
    SkeletonBox,
} from './styles'

const CompactCardSkeleton: React.FC = () => {
    return (
        <CompactCardSkeletonContainer>
            <CompactCardContentSection>
                <CompactCardTopContent>
                    <SkeletonBox $width="40%" $height="0.875rem" />
                    <SkeletonBox $width="80%" $height="1rem" />
                    <SkeletonBox $width="60%" $height="0.875rem" />
                    <SkeletonBox $width="50%" $height="0.875rem" />
                    <SkeletonBox $width="25%" $height="0.875rem" />
                </CompactCardTopContent>
                <CompactCardBottomSection>
                    <SkeletonBox $width="45%" $height="0.875rem" borderRadius="1rem" />
                    <SkeletonBox $width="60%" $height="1rem" />
                    <SkeletonBox $width="90%" $height="1.25rem" />
                </CompactCardBottomSection>
            </CompactCardContentSection>
            <CompactCardImageSkeleton />
        </CompactCardSkeletonContainer>
    )
}

export default CompactCardSkeleton
